export const initialUserDiagnoses = [
  {
    id: 1,
    code: 'A04.7',
    description:
      'C. Diff colitis'
  },
  {
    id: 2,
    code: 'A08.11',
    description:
      'Norovirus'
  },
  {
    id: 3,
    code: 'A09',
    description:
      'Infectious gastroenteritis and colitis, unspecified'
  },
  {
    id: 4,
    code: 'A15.0',
    description:
      'Tuberculosis of lung'
  },
  {
    id: 5,
    code: 'A37.90',
    description:
      'Pertussis'
  },
  {
    id: 6,
    code: 'A41.9',
    description:
      'Sepsis'
  },
  {
    id: 7,
    code: 'A49.02',
    description:
      'MRSA Bacteremia'
  },
  {
    id: 8,
    code: 'A64',
    description:
      'Unspecified Sexually Transmitted Disease'
  },
  {
    id: 9,
    code: 'E03.9',
    description:
      'Hypothyroidism'
  }
];

export const initialSystemDiagnoses = [
  {
    id: 101,
    code: 'A04.7',
    description:
      'C. Diff colitis'
  },
  {
    id: 102,
    code: '',
    description:
      'Abdominal Pain'
  },
  {
    id: 103,
    code: '',
    description:
      'Patient denied recent traveling or eating out in a restaurant'
  }
];